import ReactGA from 'react-ga';
import { config } from '_config';

if (typeof window !== 'undefined') {
  ReactGA.initialize(config.gaId);
  ReactGA.plugin.require('ecommerce');
}

export default ReactGA;
